export default {"src":"/_next/static/media/Michigan.7b36a87a.svg","height":649,"width":800,"blurWidth":0,"blurHeight":0};